module.exports = __webpack_public_path__ + "fonts/Graphik-SuperItalic.5afab951.ttf";